import { Dialog, DialogContent, DialogProps } from "@mui/material";
import { Box } from "@mui/system";

import AppModalTitle from "@/common/components/Modals/AppModalTitle";

import DepartmentCreateUpdate, { DepartmentCreateUpdateProps } from "./DepartmentCreateUpdate";

export interface OwnProps {
  createUpdateProps: DepartmentCreateUpdateProps;
}

type Props = OwnProps & DialogProps;

export default function DepartmentCreateUpdateModal({ createUpdateProps, ...dialogProps }: Props) {
  const isCreate = !createUpdateProps.departmentId;

  return (
    <Dialog fullWidth maxWidth='md' {...dialogProps}>
      <AppModalTitle
        onClose={() => dialogProps?.onClose && dialogProps?.onClose({}, "escapeKeyDown")}
      >
        {isCreate ? "Create new" : "Edit"} department
      </AppModalTitle>
      <DialogContent>
        <Box sx={{ py: 1 }}>
          <DepartmentCreateUpdate {...createUpdateProps} />
        </Box>
      </DialogContent>
    </Dialog>
  );
}
